import "./NotFoundPage.scss";

function NotFoundPage() {
    return (
        <section className="not-found">
            <h1 className="not-found__title">404 - Page not Found ☹️</h1>
        </section>
    );
}

export default NotFoundPage;
